import useBoundDashboardStore from '../store/dashboardGlobalStore'

export const useDashboardComputedFunctions = () => {
    const [getCourierLocation, getUnassignedOrderTotalValue, getCourierEtaById, getOrderEDTByUUID] = useBoundDashboardStore((state) => [
        state.getCourierLocation,
        state.getUnassignedOrderTotalValue(),
        state.getCourierEtaById,
        state.getOrderEDTByUUID
    ])

    return {
        getCourierLocation,
        getUnassignedOrderTotalValue,
        getCourierEtaById,
        getOrderEDTByUUID
    }
}

export default useDashboardComputedFunctions
